export const TEMPLATE_PHOTOS_MODAL_STATES = {
  maxCountError: 'maxCountError',
  delete: 'delete',
  viewPhoto: 'viewPhoto',
};
